var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("table",null,{"loading":_vm.loading,"donors":_vm.donors,"internalCheckedDonors":_vm.internalCheckedDonors,"fields":_vm.fields}),(_vm.donors.length)?_vm._t("pagination",null,{"page":_vm.page,"updatePage":(v) => (_vm.page = v),"total":_vm.total,"perPage":_vm.perPage}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }